module.exports = __webpack_public_path__ + "static/media/Union.bb9a06a9.png";